
/* eslint no-unused-vars: 0 */
import React from 'react';

const RadioGroup = props => {
    const { name, label, onChange, options, ...rest } = props;

    return (
        <div className="app__custom-radiogroup">
            <div className="app__editable-input__label">{label}</div>
            {options.map(option => (
                <label className="app__custom-radiogroup__input">
                    <input
                        type="radio"
                        name={name}
                        onChange={onChange}
                        {...rest}
                        value={option.value}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/elements/RadioGroup.jsx